import React, { useState, useEffect } from "react";
import ViewUserForm from "./ViewUserForm";
import EditUserForm from "./EditUserForm"; // Import Edit Form
import ResetPin from "./ResetPin"; // Import ResetPin component
import AddUserForm from "./AddUserForm";


const UserSearch = ({ refreshTrigger }) => {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [showUserDataForm, setShowUserDataForm] = useState(false);
  const [showEditUserForm, setShowEditUserForm] = useState(false); // Manage Edit Form Visibility
  const [resetUserId, setResetUserId] = useState(null);
  const [showAddUserForm, setShowAddUserForm] = useState(false)

  


  // Fetch all users including their membership tier
  const fetchUsers = () => {
    fetch("/api/admin/users")
      .then((response) => response.json())
      .then((data) => setUsers(data))
      .catch((error) => console.error("Error fetching users:", error));
  };

  // Fetch user details and transactions
  const handleViewUser = (userId) => {
    // Fetch user details
    fetch(`/api/admin/users/${userId}`)
      .then((response) => response.json())
      .then((user) => {
        setSelectedUser(user);
        setShowUserDataForm(true); // Open modal after data is loaded
      })
      .catch((error) => console.error("Error fetching user details:", error));

    // Fetch transaction history
    fetch(`/api/admin/users/${userId}/transactions`)
      .then((response) => response.json())
      .then((transactions) => setTransactionHistory(transactions))
      .catch((error) => console.error("Error fetching transaction history:", error));
  };

  // Open Reset Pin Form
  const handleResetPin = (userId) => {
    setResetUserId(userId); // Set user to reset pin
  };

    // ✅ Open Add User Form
    const handleAddUser = () => {
      setShowAddUserForm(true);
    };

  // Open Edit Form
  const handleEditUser = (user) => {
    setSelectedUser(user);
    setShowEditUserForm(true);
  };

  // Save updated user info
  // Function to update the user list after edit
  const handleSaveUser = () => {
    fetchUsers(); // Refresh user list from backend
    setShowEditUserForm(false); // Close the edit form
  };

    // ✅ Refresh User List After Adding
    const handleUserAdded = () => {
      fetchUsers();
      setShowAddUserForm(false);
    };




  useEffect(() => {
    fetchUsers();
  }, [refreshTrigger]);

  const filteredUsers = users.filter((user) =>
    (user.first_name?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
    (user.last_name?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
    (user.email?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
    (user.phone?.toLowerCase() || "").includes(searchQuery.toLowerCase())
  );

  return (
    <div className="user-list-container">
      <h2>User List</h2>
      <div>
        <label>Search Users:</label>
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <div className="button-container">
      <button className="add-user-button" onClick={handleAddUser}>Add User</button>
      </div>
      <div className="UserList-container">
        <table>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Access Level</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <tr key={user.user_id || user.phone}>
                  <td>{user.first_name}</td>
                  <td>{user.last_name}</td>
                  <td>{user.email}</td>
                  <td>{user.phone}</td>
                  <td>{user.role_name || "N/A"}</td> {/* Show Membership Tier */}
                  <td>
                    <button onClick={() => handleEditUser(user)}>Edit</button>
                    <button onClick={() => handleResetPin(user.user_id)}>Reset Pin</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No users match your search.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal for Viewing User Details */}
      {showUserDataForm && selectedUser && (
        <ViewUserForm
          selectedUser={selectedUser}
          transactionHistory={transactionHistory}
          onClose={() => setShowUserDataForm(false)}
        />
      )}

      {/* Modal for Editing User */}
      {showEditUserForm && selectedUser && (
        <EditUserForm
          user={selectedUser}
          onClose={() => setShowEditUserForm(false)}
          onSave={handleSaveUser}
        />
      )}

      {/* Modal for Resetting User PIN */}
      {resetUserId && (
        <ResetPin userId={resetUserId} onClose={() => setResetUserId(null)} />
      )}

            {/* ✅ Add User Modal */}
            {showAddUserForm && (
        <AddUserForm
          onClose={() => setShowAddUserForm(false)}
          onUserAdded={handleUserAdded}
        />
      )}
    </div>
  );
};

export default UserSearch;
